import axios from 'axios'
import Swal from 'sweetalert2'
import Cookies from 'js-cookie'
import { Fragment, useEffect } from 'react'
import { Col, Modal, Row, Button, FormControl } from 'react-bootstrap'
import styled from 'styled-components'

import config from '../../config'
import { useState } from 'react'

const LotteryModal = (props) => {
  const { open = false, onClose = () => {} } = props

  const [data, setData] = useState({
    single: 0,
    series: 0,
    lottery: {},
    total: 0,
  })

  useEffect(() => {
    if (!open) return
    ;(async () => {
      try {
        const res = await axios.get(`${config.apiAdminGateway}/api/v2/admin/lotteries/count`, {
          params: { isPublish: false },
          headers: { Authorization: `Bearer ${Cookies.get('accessToken')}` },
        })

        const {
          status: { code, description },
          data: result,
        } = res.data

        if (code !== 0) {
          throw new Error(description)
        }

        setData({
          single: Number(result.single),
          series: Number(result.series),
          total: Number(result.total),
          lottery: Object.keys(result.lottery).reduce(
            (acc, cur) => ({
              ...acc,
              [Number(cur)]: {
                value: Number(result.lottery[cur]),
                selectValue: 0,
              },
            }),
            {},
          ),
        })
      } catch (err) {
        Swal.fire({
          title: 'Error',
          text: err.message,
          icon: 'error',
        })
      }
    })()
  }, [open])

  if (!open) return <></>

  const onUpdatePercentage = (count, selectValue) => {
    setData({
      ...data,
      lottery: {
        ...data.lottery,
        [count]: {
          ...data.lottery[count],
          selectValue: Number(selectValue),
        },
      },
    })
  }

  const summary = Object.keys(data.lottery).reduce(
    (prev, cur) => {
      if (data.lottery[cur].selectValue === 0) {
        return prev
      }

      if (cur !== '1') {
        prev.series += data.lottery[cur].selectValue
      }
      prev.total += Number(cur) * data.lottery[cur].selectValue
      prev.lottery[cur] = data.lottery[cur].selectValue

      return prev
    },
    {
      series: 0,
      total: 0,
      lottery: {},
    },
  )

  const onPublish = async () => {
    if (Object.keys(summary.lottery).length === 0) {
      return
    }

    if (!window.confirm('Are you sure ?')) {
      return
    }

    try {
      const res = await axios.post(
        `${config.apiAdminGateway}/api/v2/admin/lotteries/multi/publish`,
        { lotteries: summary.lottery },
        { headers: { Authorization: `Bearer ${Cookies.get('accessToken')}` } },
      )

      const {
        status: { code, description },
        data: { lotteries },
      } = res.data

      if (code !== 0) {
        throw new Error(description)
      }

      Swal.fire({
        title: 'Success',
        html:
          '<pre>' +
          Object.keys(lotteries).reduce((prev, cur) => {
            const lotteryCount = Number(lotteries[cur]).toLocaleString()
            const seriesCount = Number(lotteries[cur] / cur).toLocaleString()
            return (prev += `ชุด ${cur} ใบ สำเร็จ ${seriesCount} ชุด (${lotteryCount} ใบ)\n`)
          }, '') +
          '</pre>',
        icon: 'success',
      })
      onClose()
    } catch (err) {
      Swal.fire({
        title: 'Error',
        text: err.message,
        icon: 'error',
      })
    }
  }

  const Summary = () => {
    if (summary.total === 0) {
      return null
    }

    return (
      <>
        {Object.keys(summary.lottery).map((c) => {
          if (c === '1') {
            return <div key={`select-lottery-${c}`}>{`เดี่ยว ${summary.lottery[c].toLocaleString()} ใบ`}</div>
          }
          return <div key={`select-lottery-${c}`}>{`ชุด ${c} ใบ ${summary.lottery[c].toLocaleString()} ชุด`}</div>
        })}
        {summary.series > 0 && <div>{`รวมชุด ${summary.series.toLocaleString()} ชุด`}</div>}
        <div>{`รวม ${summary.total.toLocaleString()} ใบ`}</div>
      </>
    )
  }

  return (
    <Modal
      show={open}
      onHide={onClose}
      backdrop="static"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Lottery Temp</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          {Object.keys(data.lottery).map((count) => (
            <InputSlider
              key={`count-${count}`}
              text={`ชุด ${count} ใบ :`}
              count={count}
              value={data.lottery[count].value}
              selectValue={data.lottery[count].selectValue}
              onUpdatePercentage={onUpdatePercentage}
            />
          ))}
        </Container>
        <Summary />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="primary" onClick={onPublish}>
          Publish
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const InputSlider = ({
  text = '',
  count = 0,
  value = 0,
  selectValue = 0,
  onUpdatePercentage = (c = 0, v = '') => {},
}) => {
  return (
    <>
      <Row>
        <Col>
          {text}&nbsp;
          {value.toLocaleString()} ชุด
        </Col>
      </Row>
      <Row>
        <Col>
          <input
            type="range"
            min={0}
            max={value}
            value={selectValue}
            style={{ width: '100%', margin: '8px 0px' }}
            onChange={(e) => {
              onUpdatePercentage(count, e.target.value)
            }}
          />
          {Math.round((selectValue / value) * 100)}% ({selectValue.toLocaleString()} ชุด)
          <input
            min="0"
            max={value}
            value={selectValue}
            style={{
              margin: '0px 8px',
              borderRadius: '8px',
              border: '1px solid #ced4da',
              padding: '0px 8px',
            }}
            onChange={(e) => {
              if (e.target.value === '') {
                onUpdatePercentage(count, '0')
                return
              }

              if (/^[0-9]+$/.test(e.target.value)) {
                let valueCount = Number(e.target.value)
                if (valueCount > value) {
                  valueCount = value
                }

                onUpdatePercentage(count, valueCount.toString())
              }
            }}
          />
        </Col>
      </Row>
      <hr />
    </>
  )
}

const Container = styled.div`
  width: 100%;
  min-height: 30vh;
  max-height: 70vh;
  overflow: auto;
`

export default LotteryModal
